import { useEffect, useState } from "react";

// Chave inválida/sem API habilitada/sem domínio autorizado NÃO lança
// exceção nenhuma no React — é uma falha assíncrona dentro do script do
// próprio Google, que só chama esse callback global (`gm_authFailure`, nome
// fixo definido pela API deles). Sem isso, quem usa Google Maps nunca
// saberia que a falha aconteceu (o mapa só fica uma caixa em branco).
export function useGoogleMapsAuthFailure() {
  const [authFailed, setAuthFailed] = useState(false);
  useEffect(() => {
    (window as unknown as { gm_authFailure?: () => void }).gm_authFailure = () =>
      setAuthFailed(true);
    return () => {
      delete (window as unknown as { gm_authFailure?: () => void }).gm_authFailure;
    };
  }, []);
  return authFailed;
}
